import { createAsyncThunk } from "@reduxjs/toolkit";
import { ThunkApi } from "../store.ts";
import {
  CalculateOfferRequest,
  EditOfferResponse,
  QineticNegotiationApi,
} from "../../orchestrator-api-client";
import { LayoutError } from "../slices/layout/types/layout-error.ts";
import { pushErrorMonitor } from "../../features/analytics/analytics.service.ts";

export const editOffer = createAsyncThunk<
  EditOfferResponse,
  CalculateOfferRequest,
  ThunkApi
>("editOffer", async (args, { rejectWithValue }) => {
  try {
    const response = await new QineticNegotiationApi().editOffer(args);
    const { data } = response;

    return data;
  } catch (err: any) {
    pushErrorMonitor(err); //send error push monitor
    const error: LayoutError = {
      title: "Calcolo rata",
      description:
        "Non siamo riusciti a calcolare la rata.\n Puoi riprovare o contattare il supporto",
      error: err.message,
    };
    return rejectWithValue(error);
  }
});
